<template>

</template>

<script>
import competitionUtil from "@/components/competition/competitionUtil";
import {competitionStatus,categoryType} from "@/service/competitionService";
import util from "@/mixins/util";

const {filterConfig} = competitionUtil
export default {
  name: "CompetitionFilterDefaultLayout",
  mixins: [],
  components: {
  },
    inject: ['setPage', 'setFilter'],
  provide() {
    return{

    }
  },
  props: {
      filterData: {default: () => {}},
      paginationData: {default: {total: 0, page: 0, size: 0,}},
  },
  data() {
    return{
        filterStatus:'',
        filterDate: '',
        searchInputOption: 'ti',
        searchInput: '',
        filterCategory : '',
        competitionStatus : competitionStatus,
        categoryType:categoryType,
        size: 10,
        sizeList: [10, 30, 50],
        filterPrice:['','']
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
      this.setterFilterDataInData();

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{
      setterFilterDataInData() {
          let classnames = Object.keys(this.filterData);
          classnames.forEach(classname => {
              let obj = this.filterData[classname];
              let type = filterConfig[obj.key].type;
              if (this.hasOwnProperty(classname)) {
                  if (type == 'query') {
                      this[classname] = obj.query;
                      if (this.hasOwnProperty(classname + 'Option')) {
                          this[classname + 'Option'] = obj.key;
                      }
                  } else if (type === 'between') {
                      this[classname] = [obj.start, obj.end];
                  } else if (type === 'match') {
                      let arr = obj.value.split(',');
                      if (arr.length > 1) {
                          let numArr = []
                          for (let i of arr) {
                              numArr.push(Number(i))
                          };
                          this[classname] = numArr
                      } else if (isNaN(obj.value)) {
                          this[classname] = obj.value;
                      } else {
                          this[classname] = Number(obj.value);
                      }

                  }else if(type === 'terms') {
                      if(isNaN(obj.terms[0])) {
                          this[classname] = obj.terms[0];
                      }else{
                          this[classname] = Number(obj.terms[0]);
                      }

                  }

              }
          })
          this.size = this.paginationData.size;
      },
      // 데이터가 1개이지만 array형식으로 보내야 할 때 사용
      setFilterArrayFunc(key, value) {
          let arr = []
          if (!util.isEmpty(value)) {
              arr.push(value)
          }
          this.setFilter(key, arr);
      },
      setFilterFunc(key, value) {
          this.setFilter(key, value);
      },

      changePage(key, value) {
          this.setPage(key, value);
          this.setPage('page', 1);
      },
      checkFilterData() {
          return this.filterDate != null && this.filterDate.length > 0;
      },
      searchFunc(){
          this.setFilter(this.searchInputOption, this.searchInput);
          this.setFilter('pr', this.filterPrice);
      },
  },
  watch: {

  },
}
</script>

<style scoped>

</style>
